import { FC, SVGProps } from 'react'

export const Wellbeing: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 33 32"
		fill="none"
		{...props}
	>
		<rect
			x="4.1665"
			y="7.66669"
			width="24.6667"
			height="18"
			rx="3"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<path
			d="M21.8332 6.66669V6.66669C21.8332 5.42418 21.8332 4.80292 21.6302 4.31286C21.3595 3.65946 20.8404 3.14033 20.187 2.86967C19.6969 2.66669 19.0757 2.66669 17.8332 2.66669H15.1665C13.924 2.66669 13.3027 2.66669 12.8127 2.86967C12.1593 3.14033 11.6401 3.65946 11.3695 4.31286C11.1665 4.80292 11.1665 5.42418 11.1665 6.66669V6.66669"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.8335 16.6667H21.1668"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M16.5 12L16.5 21.3333"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
